import api from '@services/api.service'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'
import { audioUrl } from '@store/slices/audio.slice'

export const generateAudioFromText = createAsyncThunk(
  'aiMetadata/approve-outline',
  async (props: { text: string; voiceId?: EntityId }) => {
    const data: any = { text: props.text }
    if (props.voiceId !== undefined) data.voiceId = props.voiceId
    try {
      const response = await api.post(`${audioUrl}generateFromString/`, data)
      return response.data as string
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `${serverError.message || 'Nepodařilo se vygenerovat Audio'}`
        )
      } else {
        toast.error('Nepodařilo se vygenerovat Audio')
      }
      throw axiosError
    }
  }
)
